// Regras puras da tela de Informativos: metadados de prioridade, definição
// dos chips de filtro e o trecho exibido na linha da tabela.
// Sem React — testado em __tests__/announcementRules.test.js.
import { i18n } from "../../translate/i18n";

// priority: 1 alta, 2 média, 3 baixa (contrato do backend — não renumerar).
export const PRIORITIES = Object.freeze({
  1: { key: "high", color: "#F87171", tone: "toneError", stateKey: "error" },
  2: { key: "medium", color: "#FBBF24", tone: "toneWarning", stateKey: "warning" },
  3: { key: "low", color: "#22D3EE", tone: "toneInfo", stateKey: "info" },
});

export const priorityMeta = (priority) => {
  const meta = PRIORITIES[Number(priority)] || PRIORITIES[3];
  return { ...meta, label: i18n.t(`announcements.priority.${meta.key}`) };
};

// Chips do mockup. `query` é o que vai na querystring de GET /announcements —
// as contagens vêm de `totals`, calculado no backend sobre o conjunto todo
// (contar só as linhas já carregadas mentiria com o scroll infinito).
export const FILTER_CHIPS = Object.freeze([
  { id: "all", labelKey: "announcements.filters.all", totalKey: "all", query: {} },
  { id: "active", labelKey: "announcements.filters.active", totalKey: "active", query: { status: "active" } },
  { id: "inactive", labelKey: "announcements.filters.inactive", totalKey: "inactive", query: { status: "inactive" } },
  { id: "high", labelKey: "announcements.filters.high", totalKey: "highPriority", query: { priority: 1 } },
  { id: "media", labelKey: "announcements.filters.media", totalKey: "withMedia", query: { hasMedia: "true" } },
]);

export const chipsWithTotals = (totals = {}, activeId = "all") =>
  FILTER_CHIPS.map((chip) => ({
    ...chip,
    label: i18n.t(chip.labelKey),
    // undefined (totais ainda não vieram) some do chip; 0 é um número legítimo.
    count: totals[chip.totalKey] === undefined ? null : Number(totals[chip.totalKey]),
    active: chip.id === activeId,
  }));

export const chipQuery = (chipId) => {
  const chip = FILTER_CHIPS.find((c) => c.id === chipId);
  return chip ? { ...chip.query } : {};
};

// Trecho de uma linha só embaixo do título. Colapsa quebras de linha para o
// texto não empurrar a linha da tabela.
export const excerpt = (text, max = 120) => {
  const flat = String(text || "").replace(/\s+/g, " ").trim();
  if (flat.length <= max) return flat;
  return `${flat.slice(0, max - 1).trimEnd()}…`;
};

// Contador do modal. Conta o texto cru, sem colapsar espaços.
export const charCount = (text) => String(text || "").length;
